import * as ACTION from './vouchers.actionTypes';

export const saveVouchers = (vouchers) => async (dispatch) => {
    dispatch({
        type: ACTION.VOUCHERS_BUY_DEALER,
        result: vouchers,
    })
};